<template>
    <div v-if="isNote" class="order_content__info_item" :class="classItem">
        <div class="order_content__info_item_main_note">
            {{ note }}
        </div>
    </div>
    <div v-else class="order_content__info_item" :class="classItem">
        <div v-if="isProductImage" class="order_content__info_item_img">
                <picture>
                    <source :srcset="productImageWebp" type="image/webp"/>
                    <source :srcset="productImagePng" type="image/png"/>
                    <img :src="productImagePng" alt="product image"/>
                </picture>
<!--            <img :src="productImage">-->
        </div>
        <div class="order_content__info_item_main">
            <div class="order_content__info_item_main_wrapper">
                <div class="order_content__info_item_main_name">
                    {{ nameItem }}
                </div>
                <div v-if="isDiscountPercent" class="order_content__info_item_main_discount_percent">
                    {{ discountPercent }}
                </div>
            </div>
            <div v-if="isDiscountSum" class="order_content__info_item_main_discount_sum">
                {{ discountSum }}
            </div>
        </div>
        <div v-if="isSumOrder" class="order_content__info_item_price">
            {{ sumOrder }}
        </div>
    </div>
    <ul v-if="isModifierList" class="order_content__info_item_list">
        <order_content_info_item_modifier_item
            v-for="item in modifierList"
            :key="'order_content_info_item_modifier_item' + item.id"
            :item="item"
            :currencyUser="currencyUser"
        />
    </ul>

</template>

<script>
import order_content_info_item_modifier_item from "./OrderContentInfoItemModifierItem.vue";
import formatNumber from "../../../mixins/formatNumber";
import {createHelpers} from "vuex-map-fields";
const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})

export default {
    name: "order_content_info_item",
    props: {
        item: {
            type: Object,
            required: true,
        },
        isTotal: {
            type: Boolean,
            required: true,
        },
        currencyUser: {
            type: String,
            required: true,
        }
    },
    components: {order_content_info_item_modifier_item},
    mixins: [formatNumber],
    computed: {
        ...mUser([
            'user',
        ]),
        classItem() {
            return {
                'total': this.isTotal,
            }
        },
        note() {
            return '';
        },
        nameItem() {
            if (this.item.qty && this.item.title) {
                return this.item.qty.toString() + ' X ' + this.item.title;
            }
            return '';
        },
        discountPercent() {
            if (this.item.item_discount && this.item.item_cost && this.item.item_cost !== 0 && this.user.locale) {
                return this.toCurrency(Math.round(this.item.item_discount / this.item.item_cost * 100).toString(), '') + '%';
            }
            return '';
        },
        discountSum() {
            if (this.item.item_discount && this.user.locale) {
                return this.toCurrency(this.item.item_discount, this.currencyUser,'uk-UA', 2);
            }
            return '';
        },
        sumOrder() {
            if (this.item.item_cost && this.user.locale) {
                return this.toCurrency(this.item.item_cost, this.currencyUser, 'uk-UA', 2);
            }
            return '';
        },
        isNote() {
            return this.note !== '';
        },
        isDiscountPercent() {
            return this.discountPercent !== '';
        },
        isDiscountSum() {
            return this.discountSum !== '';
        },
        isSumOrder() {
            return this.sumOrder !== '';
        },
        isModifierList() {
            if (this.modifierList.length > 0) {
                return true;
            }
            return false;
        },
        modifierList() {
            if (this.item.modifiers && Array.isArray(this.item.modifiers)) {
                return this.item.modifiers;
            }
            return [];
        },
        productImage(){
            if(this.item.image){
                return this.item.image.replace("{width}", "50").replace("{height}", "50");
            }
            return '';
        },
        productImageWebp(){
            if(this.isProductImage){
                return this.productImage;
            }
            return '';
        },
        productImagePng(){
            if(this.isProductImage){
                return this.productImage.replace(".webp", ".png");
            }
            return '';
        },
        isProductImage(){
            return this.productImage !== '';
        }
    },
}
</script>
